import React from 'react'
import { Title } from '../../style'
import Accordions from 'components/Accordions'
import { HelpStyle } from './style'
import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

const Help = (props) => {
	const { terms = [] } = useSelector((state) => state.login)

	return (
		<HelpStyle className='col-md-6 col-sm-12'>
			<Title>
				<FormattedMessage
					id='login.accordion.header'
					defaultMessage='ABOUT RETURNS AND EXCHANGES'
				/>
			</Title>
			<Accordions list={terms} />
		</HelpStyle>
	)
}
export default Help
